__turbopack_context__.v({
  "content": "_3JWxFa_content",
  "description": "_3JWxFa_description",
  "footer": "_3JWxFa_footer",
  "header": "_3JWxFa_header",
  "root": "_3JWxFa_root",
  "title": "_3JWxFa_title",
});
